import { useCallback } from 'react';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';

import { AnalyticsEvent, analyticsEventNames, BaseAnalyticsEventProperties } from './events';

export const useAnalytics = () => {
  const user = useGetUser();

  return useCallback((analyticsEvent: AnalyticsEvent) => {
    if (typeof window.FullStory === 'undefined') {
      return;
    }

    const eventProperties: BaseAnalyticsEventProperties | Record<string, unknown> = {
      ...('eventProperties' in analyticsEvent ? analyticsEvent.eventProperties : {}),
      ...(user
        ? {
          displayName: `${user.company?.name} - ${user.name}`,
          email: user.email,
          uid: user.id,
        }
        : {}),
    };

    window.FullStory.event(analyticsEventNames[analyticsEvent.eventType], eventProperties);
  },
  [user]);
};
